import { SavedMessagesModalAction } from '../actions/savedMessagesModal'

type SavedMessagesModalState = {
  isOpen: boolean
  textToInsert: string
}

export type SavedMessagesRootState = {
  savedMessagesModal: SavedMessagesModalState
}

const initialState: SavedMessagesModalState = {
  isOpen: false,
  textToInsert: null,
}

const savedMessagesModal = (
  state = initialState,
  action: SavedMessagesModalAction,
) => {
  switch (action.type) {
    case 'OPEN_SAVED_MESSAGES_MODAL':
      return {
        ...state,
        isOpen: true,
      }
    case 'CLOSE_SAVED_MESSAGES_MODAL':
      return {
        ...state,
        isOpen: false,
      }
    case 'SET_SAVED_MESSAGE_TEXT_TO_INSERT':
      return {
        ...state,
        isOpen: false,
        textToInsert: action.textToInsert,
      }
    case 'CLEAR_SAVED_MESSAGE_TEXT_TO_INSERT':
      return {
        ...state,
        textToInsert: null,
      }
    default:
      return state
  }
}

export default savedMessagesModal
